import { render } from "./collection-hero.vue?vue&type=template&id=f702ecca"
import script from "./collection-hero.vue?vue&type=script&lang=js"
export * from "./collection-hero.vue?vue&type=script&lang=js"

import "./collection-hero.vue?vue&type=style&index=0&id=f702ecca&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__